import React from 'react';
import { graphql, createRefetchContainer } from 'react-relay';
import { withRouter } from 'react-router-dom';
import { Table, TableBody, TableHeader, TableRow, TableHeaderColumn } from 'material-ui/Table';
import Paper from 'material-ui/Paper';
import FlatButton from 'material-ui/FlatButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import NavigationRefresh from 'material-ui/svg-icons/av/replay';
// All materials
import CheckIcon from 'material-ui/svg-icons/navigation/check';
import { containerHeader, styles, paperStyle } from '../../lib/styles';
// media-gallery
import { MediaGalleryFilter } from './MediaGalleryFilter';
import MediaGalleryItem from './MediaGalleryItem';
import MediaGalleryListItem from './MediaGalleryListItem';
import PopupMeta from './PopupMeta';
// Pagination
import Pagination from '../controls/pagination/pagination';
// Отображение скрытых материалов
import ShowHiddenElement from '../showHiddenElement';
// style
import './media-gallery.css';
import styleGallery from './media-gallery-style';
import { table } from '../../lib/styles/table';
import '../ui/table.css';
//
import { staticUrl } from '../../lib/config';

type Props = {
	routePersistentPage: boolean,
	viewer: Object,
	viewType: string,
	insertItem: ?Function,
	pagination: boolean,
	wrapper: string,
	// встроить элемент или отобразить список материалов
	componentState: boolean,
	// встроить элемент, после загрузки
	insertAfterUpload: boolean,
	// встроить элемент после клика или выделить
	insertAfterClick: boolean,
	type: ?string,
	wrapper: ?string,
	viewer: Object,
	location: Object,
	styleTitle: ?Object,
	relay: Object,
};

type State = {
	componentState: ?boolean,
	filterShowId: ?string,
	filterTopicId: ?string,
	hideModalWindow: ?boolean,
	insertAfterUpload: ?boolean,
	mediaFiles: Array<Object>,
	openEditWindow: boolean,
	openMediaUploadItem: boolean,
	orientation: ?string,
	orientationShow: boolean,
	pageCursor: number,
	pagination: boolean,
	selectedItemId: string,
	setPageCursor: number,
	states: ?Array<string>,
	totalPages: number,
	type: string,
	viewType: string,
	selectedItems: Array<Object>,
};

/**
 * Объединение двух массивов с объектами
 * @param arr1
 * @param arr2
 * @returns {Buffer|{type, parts}|*|T[]|string}
 */
function arrayUnion(arr1: Array, arr2: Array) {
	const union = arr1.concat(arr2);

	for (let i = 0; i < union.length; i += 1) {
		for (let j = i + 1; j < union.length; j += 1) {
			if (union[i].id === union[j].id) {
				union.splice(j, 1);
				j -= 1;
			}
		}
	}

	return union;
}

class MediaGalleryList extends React.Component<Props, State> {
	static defaultProps = {
		insertAfterClick: true,
	};

	constructor(props) {
		super(props);
		const pageNumber = this.props.location.hash ? parseInt(this.props.location.hash.replace('#', ''), 20) : 1;

		const filterValue = {};

		this.state = {
			filterValue,
			selectedItemId: '',
			viewType: props.viewType || 'grid',
			openEditWindow: false,
			openMediaUploadItem: false,
			hideModalWindow: true,
			componentState: this.props.componentState ? this.props.componentState : false,
			setPageCursor: pageNumber,
			pageCursor: pageNumber,
			filterShowId: null,
			filterTopicId: null,
			states: ['available'],
			insertAfterUpload: this.props.insertAfterUpload ? this.props.insertAfterUpload : false,
			pagination: props.pagination !== undefined ? props.pagination : true,
			type: this.props.type || this.props.location.pathname.replace('/', ''),
			totalPages: Math.ceil(this.props.viewer.mediaFiles.totalCount / 20),
			mediaFiles: this.props.viewer.mediaFiles.mediaFiles,
			selectedItems: [],
		};
	}

	componentDidMount() {
		this.onScrollGalleryWrapper();
	}

	componentWillReceiveProps(nextProps) {
		console.log(nextProps);
		if (this.state.pagination) {
			const { mediaFiles } = nextProps.viewer.mediaFiles || { mediaFiles: [] };
			this.setState({ mediaFiles });
			const x = window.scrollX;
			window.scrollTo(x, 0);
			return;
		}
		let currentMediaFiles = this.state.mediaFiles.slice(0);
		if (this.state.filterTopicId || this.state.filterShowId) {
			currentMediaFiles = nextProps.viewer.mediaFiles.mediaFiles;
		} else if (this.state.setPageCursor > 1) {
			currentMediaFiles = arrayUnion(this.state.mediaFiles, nextProps.viewer.mediaFiles.mediaFiles);
		} else {
			currentMediaFiles = arrayUnion(nextProps.viewer.mediaFiles.mediaFiles, this.state.mediaFiles);
		}
		this.setState({ mediaFiles: currentMediaFiles });
	}

	componentWillUnmount() {
		const gridWrapper = document.getElementById('gallery-inner');
		if (gridWrapper) {
			gridWrapper.removeEventListener('scroll', this.handleOnScroll);
			this.setState({ openMediaUploadItem: false });
			setTimeout(() => {
				document.getElementsByTagName('body')[0].removeAttribute('style');
			}, 250);
		}
	}

	insertMediaFiles = () => {
		const { selectedItems } = this.state;
		const { insertItem, insertMultipleMediaFiles } = this.props;

		if (selectedItems.length === 1 && insertItem) {
			insertItem(selectedItems[0]);
			return;
		}
		if (insertMultipleMediaFiles) {
			insertMultipleMediaFiles(selectedItems);
		}
	};

	// Применяем новые значения фильтров
	onAcceptFilter = (type, data) => {
		const { filterValue } = this.state;
		switch (type) {
			case 'topic':
			case 'sort':
			case 'querySearch':
			case 'show': {
				this.setState({
					filterValue: {
						...filterValue,
						[type]: {
							...data[type],
							searchText: data.searchText,
							hintText: data.hintText,
						},
					},
					mediaFiles: [],
				});
				break;
			}
			default:
				break;
		}

		const newFilter = this.state.filterValue;
		const refetchVars = () => ({
			page: 1,
			searchText: newFilter.querySearch ? newFilter.querySearch.searchText : '',
			states: this.state.states,
			topic: newFilter.topic ? newFilter.topic.id : null,
			show: newFilter.show ? newFilter.show.id : null,
			sort: newFilter.sort ? newFilter.sort.id : 'dateDesc',
		});

		const { totalCount } = this.props.viewer.mediaFiles || { totalCount: 0 };

		this.props.relay.refetch(refetchVars, null, () => {
			this.setState({
				pageCursor: 1,
				totalPages: Math.ceil(totalCount / 20),
			});
		});
	};

	changeHiddenShow = flag => {
		const stringStatus = flag ? ['deleted'] : ['available'];

		const refetchVars = () => ({
			page: 1,
			states: stringStatus,
			topic: this.state.filterTopicId,
			show: this.state.filterShowId,
			sort: this.state.filterSortId ? this.state.filterSortId : 'dateDesc',
		});
		this.props.relay.refetch(refetchVars, null, () => {
			this.setState({
				states: stringStatus,
				pageCursor: 1,
				totalPages: Math.ceil(this.props.viewer.mediaFiles.totalCount / 20),
			});
		});
	};

	// Рендерим таблицу
	renderTable = () => (
		<div>
			<Table className="table" fixedHeader>
				<TableHeader displaySelectAll={false} adjustForCheckbox={false}>
					<TableRow style={{ border: 0 }}>
						<TableHeaderColumn
							style={{
								...styleGallery.columnTitle,
								...table.th,
							}}
						>
							Название
						</TableHeaderColumn>
						<TableHeaderColumn
							style={{
								...styleGallery.columnDate,
								...table.th,
							}}
						>
							Дата
						</TableHeaderColumn>
						<TableHeaderColumn
							style={{
								...styleGallery.columnLong,
								...table.th,
							}}
						>
							Продолж-сть
						</TableHeaderColumn>
						<TableHeaderColumn
							style={{
								...styleGallery.columnStatus,
								...table.th,
							}}
						>
							Статус
						</TableHeaderColumn>
					</TableRow>
				</TableHeader>
			</Table>
			<div id="gallery-inner" style={{ overflow: 'auto' }}>
				<Table className="table">
					<TableBody showRowHover stripedRows>
						{this.renderMediaItem()}
					</TableBody>
				</Table>
			</div>
		</div>
	);
	// Рендерим элементы
	renderMediaItem = () =>
		this.state.mediaFiles.map(mediaFile => {
			if (mediaFile.type === 'live' || mediaFile.type === 'wallpaper') {
				return null;
			}
			const insertItem = this.props.location.pathname.replace('/', '') !== 'video' && this.props.location.pathname.replace('/', '') !== 'image';
			return (
				<MediaGalleryListItem
					key={mediaFile.id}
					mediaFile={mediaFile}
					selected={this.state.selectedItems.findIndex(item => item.id === mediaFile.id) > -1}
					viewType={this.state.viewType}
					onClick={() => {
						this.setState({
							selectedItemId: mediaFile.id,
							openEditWindow: true,
						});
					}}
					insertItem={item => {
						if (this.state.componentState) {
							if (this.props.insertAfterClick && this.props.insertItem) {
								this.props.insertItem(item);
							} else {
								const index = this.state.selectedItems.findIndex(si => si.id === item.id);
								if (index > -1) {
									const items = this.state.selectedItems;
									items.splice(index, 1);
									this.setState({
										selectedItems: items,
									});
									return;
								}
								this.setState({
									selectedItems: [...this.state.selectedItems, item],
								});
							}
						}
					}}
					states={this.state.states[0]}
					type={mediaFile.type}
					insertItemIcon={insertItem}
				/>
			);
		});

	getMetaInfo = metaInformation => {
		this.updateListElement(metaInformation);
	};

	// Обновляем размер высоты враппера галереи и подписываемся на скролл
	onScrollGalleryWrapper = () => {
		if (!this.state.pagination) {
			this.resizeGridWrapper();
			const gridWrapper = document.getElementById('gallery-inner');
			gridWrapper.addEventListener('scroll', this.handleOnScroll);
			if (gridWrapper.scrollHeight < gridWrapper.clientHeight) {
				this.requestContent();
			}
		}
	};

	// Обновляем значения в элементах, после их изменения
	updateListElement = data => {
		const element = document.getElementById(data.id);
		const title = element.getElementsByClassName('js-item-title')[0];
		title.innerText = data.title;
		if (data.type === 'image') {
			return;
		}
		const hash = Math.random();
		const preview = element.getElementsByClassName('js-item-img')[0];
		preview.src = `${staticUrl}/${data.preview}?${hash}`;
	};

	changePage = pageNumber => {
		const { routePersistentPage = true } = this.props;
		const refetchVars = () => ({
			page: pageNumber,
			topic: this.state.filterTopicId,
			show: this.state.filterShowId,
			sort: this.state.filterSortId ? this.state.filterSortId : 'dateDesc',
		});

		this.props.relay.refetch(refetchVars, null, () => {
			if (routePersistentPage) {
				window.location.hash = pageNumber;
			}
			this.setState({ pageCursor: pageNumber });
		});
	};

	mediaUploadWindowState = state => {
		this.setState({
			hideModalWindow: state.hideModalWindow,
			openMediaUploadItem: state.open,
		});
	};

	renderUploadFile = () => (
		<MediaGalleryItem
			type={this.state.type}
			hideModalWindow={this.state.hideModalWindow}
			open={this.state.openMediaUploadItem}
			getMediaState={() => {
				const refetchVars = () => ({
					page: 1,
					topic: this.state.filterTopicId,
					show: this.state.filterShowId,
					sort: this.state.filterSortId ? this.state.filterSortId : 'dateDesc',
				});
				this.props.relay.refetch(refetchVars, null, () => {
					this.setState({
						pageCursor: 1,
						totalPages: Math.ceil(this.props.viewer.mediaFiles.totalCount / 20),
					});
				});
			}}
			insertAfterUpload={this.state.insertAfterUpload}
			insertItem={item => {
				if (this.props.insertItem) {
					this.props.insertItem(item, true);
				}
			}}
			getOpenState={state => this.mediaUploadWindowState(state)}
			orientation={this.props.orientation}
			orientationShow={this.props.orientationShows}
		/>
	);

	// Infinite scroll
	/**
	 * Устанавливаем высоту блока с элементами галереи
	 */
	resizeGridWrapper = () => {
		setTimeout(() => {
			const wrapperHeight = this.props.wrapper ? document.getElementsByClassName(this.props.wrapper)[0].clientHeight : window.innerHeight;
			const gridWrapper = document.getElementById('gallery-inner');
			const galleryHeader = document.getElementsByClassName('js-gallery-header')[0].clientHeight;
			const height = wrapperHeight - galleryHeader - 50;
			gridWrapper.style.height = `${height}px`;
		}, 200);
	};
	/**
	 * Получаем новые данные
	 */
	requestContent = () => {
		const gridWrapper = document.getElementById('gallery-inner');
		if (this.state.pageCursor < this.state.totalPages) {
			if (this.state.setPageCursor === this.state.pageCursor) {
				this.setState({ setPageCursor: this.state.setPageCursor + 1 });
				this.changePage(this.state.pageCursor + 1);
			}
		} else {
			gridWrapper.removeEventListener('scroll', this.handleOnScroll);
		}
	};

	/**
	 * Отслеживаем скролл
	 */
	handleOnScroll = () => {
		const gridWrapper = document.getElementById('gallery-inner');
		const { scrollTop } = gridWrapper;
		const scrollHeight = gridWrapper.scrollHeight - 20;
		const clientHeight = gridWrapper.getBoundingClientRect().height;
		const scrolledToBottom = Math.ceil(scrollTop + clientHeight) >= scrollHeight;
		if (scrolledToBottom) {
			this.requestContent();
		}
	};

	render() {
		let addFileTitle = 'добавить элемент';
		let sectionTitle = 'Медиагалерея';
		if (this.state.type.length === 1) {
			switch (this.state.type[0]) {
				case 'video':
					addFileTitle = 'добавить видео';
					sectionTitle = 'Видео';
					break;
				case 'image':
					addFileTitle = 'добавить изображение';
					sectionTitle = 'Изображения';
					break;
				default:
					break;
			}
		}

		const { filterValue } = this.state;

		return (
			<section>
				{this.renderUploadFile()}
				{this.state.openEditWindow && (
					<PopupMeta id={this.state.selectedItemId} closeDialogHandle={() => this.setState({ openEditWindow: false })} />
				)}
				<Paper style={{ ...paperStyle.mainItem }}>
					<header
						style={{
							paddingTop: 5,
							paddingBottom: 0,
							...containerHeader.header,
							marginBottom: 5,
							alignItems: 'none',
						}}
						className="js-gallery-header"
					>
						<h3 style={{ ...styles.headerTitle, marginTop: 20 }}>{sectionTitle}</h3>
						<div style={{ flexGrow: 1, alignSelf: 'center' }} />
						<div style={{ display: 'flex', alignItems: 'center', ...this.props.styleTitle }}>
							<ShowHiddenElement
								onClick={state => {
									this.changeHiddenShow(state);
								}}
							/>
							<FlatButton
								label="Обновить"
								style={{ ...styles.headerButton, marginRight: -6 }}
								primary
								icon={<NavigationRefresh />}
								onClick={() => (window.location = window.location)}
							/>
							<FlatButton
								label={addFileTitle}
								style={styles.headerButton}
								primary
								icon={<ContentAdd />}
								onClick={() =>
									this.setState({
										openMediaUploadItem: true,
										hideModalWindow: false,
									})
								}
							/>
							{this.state.selectedItems.length > 0 && (
								<FlatButton
									style={styles.headerButton}
									primary
									onClick={this.insertMediaFiles}
									label="Выбрать"
									icon={<CheckIcon />}
								/>
							)}
						</div>
						<div className="header-filter--wrapper">
							<MediaGalleryFilter
								value={filterValue}
								topics={this.props.viewer.topics}
								viewType={this.state.viewType}
								type={this.state.type}
								changeViewType={type => {
									this.setState(type);
								}}
								onChange={this.onAcceptFilter}
							/>
						</div>
					</header>
					<div style={{ margin: '31px -13px 0 -12px' }}>
						{this.state.viewType === 'list' && this.renderTable()}
						{this.state.viewType === 'grid' && (
							<div>
								{this.props.type === 'showTitle' && <header className="grid-section--title">Выбрать из галереи:</header>}
								<div id="gallery-inner" className="grid-wrapper">
									{this.renderMediaItem()}
								</div>
							</div>
						)}
					</div>
				</Paper>
				{this.state.pagination && (
					<footer style={{ width: '100%', padding: '9px 0' }}>
						<Pagination totalPage={this.state.totalPages} currentPage={this.state.pageCursor} changePage={this.changePage} />
					</footer>
				)}
			</section>
		);
	}
}

export default withRouter(
	createRefetchContainer(
		MediaGalleryList,
		graphql`
			fragment MediaGalleryList_viewer on Viewer
				@argumentDefinitions(
					page: { type: "Int!" }
					topic: { type: "ID" }
					searchText: { type: "String" }
					show: { type: "String" }
					types: { type: "[MediaFileTypeEnum]" }
					sort: { type: "String" }
					states: { type: "[MediaFileStateType]" }
					#            search: {type:"String",}
				) {
				mediaFiles: mediaFilesPaginate(
					pageSize: 21
					page: $page
					topic: $topic
					searchText: $searchText
					show: $show
					types: $types
					sort: $sort
					states: $states
				) {
					totalCount
					mediaFiles {
						id
						title
						filename
						description
						alt
						show
						topics {
							id
						}
						type
						preview
						status
						updatedAt
						seoTitle
						seoDescription
						seoKeywords
						slug
					}
				}
				topics: topics(first: -1) {
					edges {
						node {
							id
							name
						}
					}
				}
				...TopicSelector_viewer
			}
		`,
		graphql`
			query MediaGalleryList_Refetch_Query(
				$page: Int!
				$topic: ID
				$searchText: String
				$show: String
				$types: [MediaFileTypeEnum]
				$sort: String
				$states: [MediaFileStateType] #        $search: String
			) {
				viewer {
					...MediaGalleryList_viewer
						@arguments(page: $page, topic: $topic, searchText: $searchText, show: $show, types: $types, sort: $sort, states: $states)
				}
			}
		`,
	),
);



// WEBPACK FOOTER //
// src/components/media/MediaGalleryList.js